import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import NavigationBar from '../../components/navigationBar';
import { CopilotChatProvider } from './copilotChatContext';
import { CopilotChatDock } from './copilotChat';

function AuthenticatedLayout() {
  return (
    <CopilotChatProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'stretch',
          minHeight: '100vh',
          width: '100%',
          overflow: 'hidden',
          bgcolor: 'var(--dust-white, #F7EDE5)',
        }}
      >
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            minHeight: { xs: 'auto', md: '100vh' },
          }}
        >
          <NavigationBar />
          <Box
            component='main'
            sx={{
              flex: 1,
              minHeight: 0,
              minWidth: 0,
              overflowY: 'auto',
              overflowX: 'auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              justifyContent: 'flex-start',
              m: 0,
              p: 0,
            }}
          >
            <Outlet />
          </Box>
        </Box>
        <CopilotChatDock />
      </Box>
    </CopilotChatProvider>
  );
}

export default AuthenticatedLayout;
